import { useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { assignToListIconRed, InfluencerRating } from "../../Components";
import { storageHandler, utils } from "../../Helpers";
import {
  Table,
  TableBody,
  TableHead,
  TableContainer,
  Paper,
  TableCell,
  TableRow,
} from "@mui/material";
import { ChartLine, ArrowUpDown, ArrowUp, ArrowDown } from "lucide-react";
import { influencerlistService } from "../../Services";

export default function ShowInfluencerList({
  setUpdateProfilePage,
  updateProfilePage,
  setUserTypeRegOrNon,
  removeInfFromList,
  setSelectedInfluencer,
  item,
  toastList,
  addToast,
  listId,
  setCountOfInf,
  setTabModal,
  listInfluencer,
  setListInfluencer,
  loadMore,
  hasMore,
  loading,
}) {
  const navigate = useNavigate();
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });
  const observerTarget = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !loading) {
          loadMore();
        }
      },
      { threshold: 0.1 }
    );

    if (observerTarget.current) {
      observer.observe(observerTarget.current);
    }

    return () => {
      if (observerTarget.current) {
        observer.unobserve(observerTarget.current);
      }
    };
  }, [hasMore, loading, loadMore]);
  const handleSort = async (key) => {
    const newDirection =
      sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";

    setSortConfig({ key, direction: newDirection });

    try {
      const payload = {
        sort: newDirection === "asc" ? key : `-${key}`,
      };
      console.log("🚀 ~ handleSort ~ payload:", payload);
      const res = await influencerlistService.getSortedInfluencerList(
        listId,
        payload
      );
      console.log("🚀 ~ handleSort ~ res:", res);
      if (res.success === true) {
        setListInfluencer(res?.data?.influencers?.data);
      }
    } catch (error) {}
  };

  const SortIcon = ({ column }) => {
    if (sortConfig.key !== column) return <ArrowUpDown size={14} />;
    return sortConfig.direction === "asc" ? (
      <ArrowUp size={14} />
    ) : (
      <ArrowDown size={14} />
    );
  };

  const removeFromList = async (event, item) => {
    event.stopPropagation();
    setTabModal("confirmDelete");
    setSelectedInfluencer(item);
  };
  const showInfProfile = (event, item) => {
    event.stopPropagation();
    storageHandler.setUserTypeForProfileItem(JSON.stringify(item.type));
    setUpdateProfilePage(!updateProfilePage);
    navigate("/brand/influencerProfile/" + item.id);
  };

  const getStringOfBio = (influencer) => {
    return influencer.bio
      ? influencer.bio !== ""
        ? utils.testJSON(influencer.bio)
          ? utils.draftJsFormatingForDetailsBio({
              data: influencer.bio,
              view: "lessview",
            })
          : influencer.bio.substring(0, 25)
        : ""
      : "";
  };
  const userDisplayFormat = (count) => {
    if (count >= 1000000000)
      return (count / 1000000000).toFixed(1).replace(/\.0$/, "") + "B";

    if (count >= 1000000)
      return (count / 1000000).toFixed(1).replace(/\.0$/, "") + "M";

    if (count >= 1000)
      return (count / 1000).toFixed(1).replace(/\.0$/, "") + "K";

    return count;
  };

  return (
    <>
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          width: "100%",
          boxShadow: "none",
          border: "none",
          height: "calc(100vh - 175px)",
          overflow: "auto",
          scrollbarWidth: "thin",
          scrollbarColor: "#e5e7eb transparent",
          position: "relative",
          transition: "opacity 0.2s",
          paddingRight: "16px",
          borderRadius: "10px",
          // Mobile horizontal scroll
          "@media (max-width: 768px)": {
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
          },
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  py: 1,
                  pl: 0,
                  pr: 2,
                  maxWidth: "400px",
                  font: "bold",
                  cursor: "pointer",
                  backgroundColor: "white",
                }}
                onClick={() => handleSort("display_name")}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "4px" }}
                >
                  {listInfluencer.length} influencers founds
                  <SortIcon column="display_name" />
                </div>
              </TableCell>
              <TableCell
                sx={{
                  py: 1,
                  px: 2,
                  textAlign: "center",
                  color: "#4b5563",
                  minWidth: "80px",
                  backgroundColor: "white",
                }}
              >
                Rating
              </TableCell>
              <TableCell
                sx={{
                  py: 1,
                  px: 2,
                  textAlign: "center",
                  color: "#4b5563",
                  backgroundColor: "white",
                }}
              >
                Platform
              </TableCell>
              <TableCell
                sx={{
                  py: 1,
                  px: 2,
                  textAlign: "center",
                  color: "#4b5563",
                  cursor: "pointer",
                  backgroundColor: "white",
                }}
                onClick={() => handleSort("followers")}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "4px",
                  }}
                >
                  Followers
                  <SortIcon column="followers" />
                </div>
              </TableCell>
              <TableCell
                sx={{
                  py: 1,
                  px: 2,
                  textAlign: "center",
                  color: "#4b5563",
                  cursor: "pointer",
                  backgroundColor: "white",
                }}
                onClick={() => handleSort("following")}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "4px",
                  }}
                >
                  Following
                  <SortIcon column="following" />
                </div>
              </TableCell>

              {/* <TableCell
                sx={{ py: 1, px: 2, textAlign: "center", color: "#4b5563" }}
              >
                Avg Likes
              </TableCell> */}
              <TableCell
                sx={{
                  py: 1,
                  px: 2,
                  textAlign: "center",
                  color: "#4b5563",
                  backgroundColor: "white",
                }}
              >
                Engagement Rate
              </TableCell>
              <TableCell
                sx={{
                  py: 1,
                  pr: 2,
                  textAlign: "center",
                  color: "#4b5563",
                  backgroundColor: "white",
                }}
              ></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listInfluencer.map((item, index) => (
              <TableRow
                key={index}
                className="text-gray-500"
                sx={{
                  borderBottom:
                    index === listInfluencer.length - 1
                      ? "none"
                      : "1px solid #e5e7eb",
                }}
              >
                <TableCell
                  sx={{
                    maxWidth: "200px",
                    pl: 0,
                    pr: 2,
                    borderBottom:
                      index === listInfluencer.length - 1 ? "none" : "none",
                    verticalAlign: "middle",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <img
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                      }}
                      src={
                        item.profile_img_url &&
                        item.profile_img_url &&
                        item.profile_img_url !== ""
                          ? item.profile_img_url
                          : `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
                      }
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
                      }}
                      alt="avatar"
                      onClick={(e) => showInfProfile(e, item)}
                    />
                    <span className="pt-1">
                      <div onClick={(e) => showInfProfile(e, item)}>
                        {item.display_name}
                      </div>
                      {/* {item.bio && item.bio !== "" && (
                        <div
                          className="bio-text-gray"
                          style={{
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            fontSize: "14px",
                          }}
                        >
                          {utils.testJSON(item.bio)
                            ? utils.draftJsFormatingForDetailsBio({
                                data: item.bio,
                                view: "fullview",
                              })
                            : item.bio}
                        </div>
                      )} */}
                      {item.bio && item.bio !== "" && (
                        <div className="tags">
                          <p className="tagstext bio-text-gray">
                            {item.bio
                              ? getStringOfBio(item) !== ""
                                ? getStringOfBio(item)
                                : ""
                              : ""}
                          </p>
                        </div>
                      )}
                    </span>
                  </div>
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom:
                      index === listInfluencer.length - 1 ? "none" : "none",
                    px: 2,
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  <div style={{ display: "inline-block" }}>
                    <InfluencerRating
                      infrating={item.rating}
                    ></InfluencerRating>
                  </div>
                </TableCell>
                <TableCell
                  className="!text-center"
                  sx={{
                    color: "#4b5563",
                    borderBottom:
                      index === listInfluencer.length - 1 ? "none" : "none",
                    px: 2,
                    textAlign: "center",
                    verticalAlign: "middle",
                    py: item.social_accounts?.length > 1 ? 2 : 1,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    {item.social_accounts?.map((account, idx) => (
                      <div
                        key={idx}
                        style={{
                          marginBottom:
                            idx < item.social_accounts.length - 1 ? "4px" : "0",
                        }}
                      >
                        {account.platform === "IG" && (
                          <img
                            src="images/instagram.svg"
                            width="28"
                            title="instagram"
                            alt="Instagram"
                          />
                        )}
                        {account.platform === "FB" && (
                          <img
                            src="images/facebook.svg"
                            width="28"
                            title="facebook"
                            alt="Facebook"
                          />
                        )}
                        {account.platform === "YT" && (
                          <img
                            src="images/youtube.svg"
                            width="28"
                            title="youtube"
                            alt="YouTube"
                          />
                        )}
                        {account.platform === "TT" && (
                          <img
                            src="images/tiktok-logo.svg"
                            width="28"
                            title="tiktok"
                            alt="TikTok"
                          />
                        )}
                      </div>
                    )) || "-"}
                  </div>
                </TableCell>
                <TableCell
                  className="!text-center"
                  sx={{
                    color: "#4b5563",
                    borderBottom:
                      index === listInfluencer.length - 1 ? "none" : "none",
                    px: 2,
                    verticalAlign: "middle",
                    py: item.social_accounts?.length > 1 ? 2 : 1,
                  }}
                >
                  {item.social_accounts?.map((account, idx) => (
                    <div
                      key={idx}
                      style={{
                        marginBottom:
                          idx < item.social_accounts.length - 1 ? "4px" : "0",
                      }}
                    >
                      {userDisplayFormat(account.followers) || "-"}
                    </div>
                  )) || "-"}
                </TableCell>

                <TableCell
                  className="!text-center"
                  sx={{
                    color: "#4b5563",
                    borderBottom:
                      index === listInfluencer.length - 1 ? "none" : "none",
                    px: 2,
                    verticalAlign: "middle",
                    py: item.social_accounts?.length > 1 ? 2 : 1,
                  }}
                >
                  {item.social_accounts?.map((account, idx) => (
                    <div
                      key={idx}
                      style={{
                        marginBottom:
                          idx < item.social_accounts.length - 1 ? "4px" : "0",
                      }}
                    >
                      {userDisplayFormat(account.following) || "-"}
                    </div>
                  )) || "-"}
                </TableCell>

                <TableCell
                  className="!text-center"
                  sx={{
                    color: "#4b5563",
                    borderBottom:
                      index === listInfluencer.length - 1 ? "none" : "none",
                    px: 2,
                    verticalAlign: "middle",
                    py: item.social_accounts?.length > 1 ? 2 : 1,
                  }}
                >
                  {item.social_accounts?.map((account, idx) => (
                    <div
                      key={idx}
                      style={{
                        marginBottom:
                          idx < item.social_accounts.length - 1 ? "4px" : "0",
                      }}
                    >
                      {account.engagement_rate === 0
                        ? "0"
                        : account.engagement_rate || "-"}
                    </div>
                  )) || "-"}
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom:
                      index === listInfluencer.length - 1 ? "none" : "none",
                    pr: 0,
                    textAlign: "right",
                    verticalAlign: "middle",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      justifyContent: "flex-end",
                    }}
                  >
                    {item.list_id !== "" && (
                      <button
                        className="w-14 h-14 border-green-600 border rounded-lg flex !justify-center items-center"
                        onClick={(e) => removeFromList(e, item)}
                      >
                        <div className="like-icon">{assignToListIconRed}</div>
                      </button>
                    )}

                    <button
                      className="w-14 h-14 bg-green-600 border rounded-lg flex !justify-center items-center"
                      onClick={(e) => showInfProfile(e, item)}
                    >
                      <ChartLine className="text-white" />
                    </button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {hasMore && (
          <div
            ref={observerTarget}
            style={{ height: "20px", margin: "10px 0" }}
          />
        )}
        {loading && (
          <div style={{ textAlign: "center", padding: "20px" }}>
            Loading more...
          </div>
        )}
      </TableContainer>
    </>
  );
}
